import { createAuthClient } from "better-auth/react";
import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import {
  inferAdditionalFields,
  anonymousClient,
} from "better-auth/client/plugins";
import { env } from "@/env";

function resolveBrowserAuthUrl(): string {
  if (typeof window === "undefined") {
    return env.NEXT_PUBLIC_AUTH_URL;
  }

  // Browser auth is always same-origin. Cloudflare owns /api/auth/* in deployed
  // environments, and next dev proxies that path to the local Auth Worker.
  return window.location.origin;
}

export const authClient = createAuthClient({
  baseURL: resolveBrowserAuthUrl(),
  plugins: [
    oauthProviderClient(),
    anonymousClient(),
    inferAdditionalFields({
      user: {
        customerId: {
          type: "string",
          required: false,
        },
        onboardingComplete: {
          type: "boolean",
          required: false,
        },
        onboardingStep: {
          type: "number",
          required: false,
        },
        isAnonymous: {
          type: "boolean",
          required: false,
        },
      },
    }),
  ],
});

export const {
  signIn,
  signOut,
  signUp,
  useSession,
  updateUser,

  changePassword,
  requestPasswordReset,
  resetPassword,
} = authClient;

// Export the full authClient to access anonymous sign-in and other methods
export { authClient as client };
